(() => {
    let isProcessing = false;
    let lastProcessTime = 0;
    let cartObserver = null;
  
    if (window.location.pathname.includes("/cart") || document.querySelector("cart-drawer")) {
      const processCartImages = () => {
        if (isProcessing) return;
        const now = Date.now();
        if (now - lastProcessTime < 500) return;
        isProcessing = true;
        lastProcessTime = now;
        try {
          if (cartObserver) cartObserver.disconnect();
          const cartItems = document.querySelectorAll(".cart-item");
          cartItems.forEach((item, index) => {
            const productLink = item.querySelector(".cart-item__name")?.href || "";
            const isDisneyProduct = productLink.includes("/products/toile-disney");
            if (!isDisneyProduct) return;
            fetch("/cart.js").then(response => response.json()).then(cart => {
                const cartItem = cart.items.find(cartItem => {
                  return cartItem.product_title?.toLowerCase().includes("disney") &&
                         cartItem.properties && 
                         cartItem.properties.DisneyPreviewURL &&
                         cartItem.properties.DisneyPreviewURL !== "null" &&
                         cartItem.properties.DisneyPreviewURL.startsWith("https://");
                });
                let disneyUrl = null;
                if (cartItem && cartItem.properties.DisneyPreviewURL) {
                  disneyUrl = cartItem.properties.DisneyPreviewURL;
                } else if (cart.note) {
                  const noteMatch = cart.note.match(/Preview URL:\s*(https:\/\/[^\s\n]+)/);
                  if (noteMatch && noteMatch[1]) disneyUrl = noteMatch[1];
                } else {
                  try {
                    const storedImages = JSON.parse(localStorage.getItem("disney_generated_images") || "[]");
                    if (storedImages.length > 0) {
                      const lastImage = storedImages[storedImages.length - 1];
                      if (lastImage && lastImage.url) disneyUrl = lastImage.url;
                    }
                  } catch (e) {}
                }
                if (disneyUrl) {
                  replaceWithDisneyImage(item, disneyUrl);
                  const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                      if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        const thumbnail = item.querySelector(".tee-cart-thumbnail");
                        if (thumbnail && !thumbnail.dataset.disneyReplaced) {
                          setTimeout(() => replaceWithDisneyImage(item, disneyUrl), 100);
                        }
                      }
                    });
                  });
                  observer.observe(item, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['src', 'href', 'class', 'id']
                  });
                  item.disneyObserver = observer;
                }
              }).catch(e => {});
          });
          document.querySelectorAll(".product-option").forEach(option => {
            const dt = option.querySelector("dt");
            if (dt && dt.textContent.includes("DisneyPreviewURL")) {
              option.style.display = "none";
            }
          });
        } catch (error) {
        } finally {
          if (cartObserver) {
            const cartForm = document.querySelector("form.cart, table.cart");
            if (cartForm) {
              cartObserver.observe(cartForm, {
                childList: true,
                subtree: true,
                characterData: false,
                attributeFilter: ["class", "style"]
              });
            }
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              cartObserver.observe(cartDrawer, {
                childList: true,
                subtree: true,
                characterData: false,
                attributeFilter: ["class", "style"]
              });
            }
          }
          isProcessing = false;
        }
      };
  
      const replaceWithDisneyImage = (item, disneyUrl) => {
        if (!disneyUrl || !disneyUrl.startsWith("https://")) return;
        const cartItemLink = item.querySelector(".cart-item__link");
        if (cartItemLink) {
          cartItemLink.innerHTML = `<img src="${disneyUrl}" alt="Disney AI Generated" style="width: 100%; height: auto; object-fit: contain; max-width: 100%; max-height: 80px; display:none;">`;
          cartItemLink.href = disneyUrl;
          cartItemLink.target = "_blank";
          cartItemLink.setAttribute("tabindex", "0");
          cartItemLink.setAttribute("aria-hidden", "false");
        }
        const teeCartThumbnail = item.querySelector(".tee-cart-thumbnail");
        if (teeCartThumbnail) {
          teeCartThumbnail.dataset.disneyReplaced = "true";
          const originalId = teeCartThumbnail.id;
          teeCartThumbnail.removeAttribute("id");
          teeCartThumbnail.className = "tee-cart-thumbnail disney-replaced";
          teeCartThumbnail.innerHTML = `<a class="tee-cart-thumbnail__link" target="_blank" href="${disneyUrl}"><img class="tee-cart-thumbnail__img" src="${disneyUrl}" alt="Disney AI Generated" width="80" height="80" style="object-fit: contain; max-width: 100%; height: auto;"></a>`;
        }
        const checkTeeInBlueRegeneration = () => {
          const thumbnail = item.querySelector(".tee-cart-thumbnail:not([data-disney-replaced])");
          if (thumbnail) {
            replaceWithDisneyImage(item, disneyUrl);
          }
        };
        let checkCount = 0;
        const intervalId = setInterval(() => {
          checkTeeInBlueRegeneration();
          checkCount++;
          if (checkCount >= 20) clearInterval(intervalId);
        }, 500);
        item.dataset.disneyUrlProcessed = disneyUrl;
      };
  
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
          setTimeout(processCartImages, 100);
          setTimeout(processCartImages, 1000);
          setTimeout(processCartImages, 3000);
        });
      } else {
        setTimeout(processCartImages, 100);
        setTimeout(processCartImages, 1000);
        setTimeout(processCartImages, 3000);
      }
  
      cartObserver = new MutationObserver(() => {
        setTimeout(processCartImages, 300);
      });
  
      setTimeout(() => {
        const cartForm = document.querySelector("form.cart, table.cart");
        if (cartForm) {
          cartObserver.observe(cartForm, {
            childList: true,
            subtree: true,
            characterData: false,
            attributeFilter: ["class", "style"]
          });
        }
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartObserver.observe(cartDrawer, {
            childList: true,
            subtree: true,
            characterData: false,
            attributeFilter: ["class", "style"]
          });
        }
      }, 1000);
  
      window.disneyFixCartThumbnails = processCartImages;
      if (!window.location.pathname.includes("/products/")) return;
    }
  
    if (!(window.location.pathname.includes("/products/toile-disney") || 
          document.title.toLowerCase().includes("toile disney") || 
          document.querySelector("h1, h2")?.textContent.toLowerCase().includes("disney"))) {
      return;
    }
  
    const API_BASE_URL = "https://disney-backend-198200133214.europe-west1.run.app";
    let remainingTries = parseInt(localStorage.getItem("disney_remaining_tries") || "3");
    let sessionToken = localStorage.getItem("disney_session") || null;
    let cleanCdnUrl = null;
    let previewUrl = null;
    let generatedImages = [];
    let isGenerating = false;
    let hasDisneyImage = false;
    let hasDisneyItemInCart = false;
    let retryCount = 0;
    let retryTimeout = null;
    let currentImageIndex = -1;
    let isRegistered = false;
    let isFinalized = false;
    let isFinalizationInProgress = false;
    let uniqueProductId = Date.now() + "-" + Math.floor(Math.random() * 1000);
    let isFirstPageLoad = !sessionStorage.getItem("disney_page_initialized");
    let noteUpdateSuccess = false;
    let noteUpdateAttempts = 0;
  
    try {
      const stored = localStorage.getItem("disney_generated_images");
      if (stored) {
        generatedImages = JSON.parse(stored);
        currentImageIndex = generatedImages.length - 1;
      }
    } catch (e) {
      generatedImages = [];
    }
  
    const getCurrentSize = () => {
      const activeRadio = document.querySelector('.tee-radio.active input[name^="size-"]');
      if (!activeRadio) return "";
      const label = activeRadio.closest(".tee-radio")?.querySelector(".tee-radio__label")?.textContent;
      if (label) {
        const sizeMatch = label.match(/(\d+\s*[xX]\s*\d+\s*cm)/);
        if (sizeMatch && sizeMatch[1]) return sizeMatch[1].replace(/\s+/g, "");
      }
      return activeRadio.value.replace(/\s+/g, "");
    };
  
    const updateCartNote = async () => {
      try {
        const previewUrlToUse = previewUrl;
        const cleanUrlToUse = cleanCdnUrl;
        const selectedOrientation = document.querySelector('input[name="availableProduct"]:checked')?.value;
        const selectedSize = getCurrentSize();
        const productId = uniqueProductId;
        if (!previewUrlToUse || !cleanUrlToUse) return false;
        const disneyId = `DISNEY-${productId}-${selectedOrientation}-${selectedSize}`;
        const disneyNote = `DISNEY PRODUIT [${disneyId}]:
    - Preview URL: ${previewUrlToUse}
    - Clean CDN URL: ${cleanUrlToUse}
    - Orientation: ${selectedOrientation}
    - Taille: ${selectedSize}`;
        const currentCartResponse = await fetch("/cart.js");
        const currentCart = await currentCartResponse.json();
        if (currentCart.note && currentCart.note.includes(`DISNEY PRODUIT [${disneyId}]`)) return true;
        let newNote = "";
        if (currentCart.note) {
          newNote = `${currentCart.note}\n\n${disneyNote}`;
        } else {
          newNote = disneyNote;
        }
        const updateResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ note: newNote })
        });
        if (!updateResponse.ok) throw new Error(`Erreur HTTP ${updateResponse.status} lors de l'ajout de note`);
        const updatedCart = await updateResponse.json();
        const success = updatedCart.note && updatedCart.note.includes(`DISNEY PRODUIT [${disneyId}]`);
        if (success) noteUpdateSuccess = true;
        return success;
      } catch (error) {
        return false;
      }
    };
  
    const retryNoteUpdate = () => {
      if (noteUpdateSuccess || noteUpdateAttempts >= 5) return;
      noteUpdateAttempts++;
      setTimeout(async () => {
        try {
          const cartResponse = await fetch("/cart.js");
          const cart = await cartResponse.json();
          const productId = uniqueProductId;
          const selectedOrientation = document.querySelector('input[name="availableProduct"]:checked')?.value;
          const disneyId = `DISNEY-${productId}-${selectedOrientation}-${getCurrentSize()}`;
          if (cart.note && cart.note.includes(`DISNEY PRODUIT [${disneyId}]`)) {
            noteUpdateSuccess = true;
          } else {
            updateCartNote();
            if (noteUpdateAttempts < 5) setTimeout(() => retryNoteUpdate(), 2000);
          }
        } catch (error) {
          if (noteUpdateAttempts < 5) setTimeout(() => retryNoteUpdate(), 2000);
        }
      }, 2500);
    };
  
    const setupEventListeners = () => {
      document.querySelectorAll('input[name^="size-"]').forEach(sizeInput => {
        sizeInput.addEventListener("change", () => {
          if (!isFirstPageLoad) {
            const selectedOrientation = document.querySelector('input[name="availableProduct"]:checked').value;
            const selectedSize = sizeInput.value;
            sessionStorage.setItem("disney_selected_orientation", selectedOrientation);
            sessionStorage.setItem("disney_selected_size", selectedSize);
            window.location.reload();
          }
        });
      });
      document.querySelectorAll('input[name="availableProduct"]').forEach(orientationInput => {
        orientationInput.addEventListener("change", () => {
          clearDisneyDisplay();
          const addToCartBtn = document.querySelector(".tee-btn--atc");
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.style.opacity = "0.5";
          }
          currentImageIndex = -1;
          const generateBtn = document.querySelector(".disney-generate-btn");
          if (generateBtn) generateBtn.textContent = "Générer";
          hasDisneyImage = false;
          isRegistered = false;
          isFinalized = false;
          isFinalizationInProgress = false;
          noteUpdateSuccess = false;
          noteUpdateAttempts = 0;
        });
      });
      const savedOrientation = sessionStorage.getItem("disney_selected_orientation");
      const savedSize = sessionStorage.getItem("disney_selected_size");
      if (savedOrientation && !isFirstPageLoad) {
        const orientationInput = document.querySelector(`input[name="availableProduct"][value="${savedOrientation}"]`);
        if (orientationInput) {
          orientationInput.click();
          sessionStorage.removeItem("disney_selected_orientation");
        }
      }
      if (savedSize) {
        setTimeout(() => {
          const sizeInput = document.querySelector(`input[name^="size-"][value="${savedSize}"]`);
          if (sizeInput) {
            sizeInput.checked = true;
            const radioContainer = sizeInput.closest(".tee-radio");
            if (radioContainer) {
              document.querySelectorAll(".tee-radio").forEach(radio => radio.classList.remove("active"));
              radioContainer.classList.add("active");
            }
          }
          sessionStorage.removeItem("disney_selected_size");
        }, 200);
      }
    };
  
    const addDisneyPropertiesToForm = () => {
      if (!cleanCdnUrl || !previewUrl) return false;
      try {
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return false;
        form.querySelectorAll('input[name^="properties[Disney"]').forEach(input => input.remove());
        const properties = [
          { name: "properties[DisneyPreviewURL]", value: previewUrl },
          { name: "properties[DisneyCleanURL]", value: cleanCdnUrl },
          { name: "properties[DisneySession]", value: sessionToken },
          { name: "properties[DisneyOrientation]", value: document.querySelector('input[name="availableProduct"]:checked').value },
          { name: "properties[DisneySize]", value: getCurrentSize() },
          { name: "properties[DisneyUniqueId]", value: uniqueProductId }
        ];
        properties.forEach(prop => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = prop.name;
          input.value = prop.value;
          input.classList.add("disney-property-field");
          form.appendChild(input);
        });
        return true;
      } catch (error) {
        return false;
      }
    };
  
    const finalizeImage = async () => {
      if (!cleanCdnUrl) return false;
      if (isFinalizationInProgress) return true;
      isFinalizationInProgress = true;
      try {
        const cleanUrl = cleanCdnUrl;
        const orientation = document.querySelector('input[name="availableProduct"]:checked')?.value === "176578" ? "verticale" : "horizontale";
        const size = getCurrentSize() || "30x20cm";
        const filename = `disney-${orientation}-${uniqueProductId}-clean-${size}`;
        let attempts = 0;
        const maxAttempts = 3;
        while (!isFinalized && attempts < maxAttempts) {
          attempts++;
          try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000);
            const response = await fetch(`${API_BASE_URL}/finalize`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                preview_cdn: cleanUrl,
                filename: filename
              }),
              signal: controller.signal
            });
            clearTimeout(timeoutId);
            if (response.ok) {
              const result = await response.json();
              isRegistered = true;
              isFinalized = true;
              if (currentImageIndex >= 0 && currentImageIndex < generatedImages.length) {
                generatedImages[currentImageIndex].registered = true;
                generatedImages[currentImageIndex].registeredFilename = filename;
                localStorage.setItem("disney_generated_images", JSON.stringify(generatedImages));
              }
              return true;
            } else {
              const errorText = await response.text();
              if (attempts < maxAttempts) await new Promise(resolve => setTimeout(resolve, 1000));
            }
          } catch (error) {
            if (attempts < maxAttempts) await new Promise(resolve => setTimeout(resolve, 1000));
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    };
  
    const createLoadingInterface = () => {
      const existingOverlay = document.querySelector(".disney-loading-overlay");
      if (!existingOverlay) return null;
      return {
        start: function() {
          existingOverlay.style.display = "flex";
          const progressBar = document.querySelector(".disney-loading-progress-bar");
          if (progressBar) {
            progressBar.className = "disney-loading-progress-bar";
            progressBar.offsetWidth;
            progressBar.classList.add("animating");
          }
          const dotsElement = document.querySelector(".disney-loading-dots");
          if (!dotsElement) return null;
          let dotCount = 0;
          return setInterval(() => {
            dotCount = (dotCount + 1) % 4;
            dotsElement.textContent = ".".repeat(dotCount || 3);
          }, 500);
        },
        complete: function(hide) {
          const progressBar = document.querySelector(".disney-loading-progress-bar");
          if (progressBar) {
            progressBar.classList.remove("animating");
            progressBar.classList.add("complete");
          }
          if (hide) {
            setTimeout(() => {
              existingOverlay.style.display = "none";   
            }, 800);
          }
        },
        updateProgress: function(percentage) {
          const progressBar = document.querySelector(".disney-loading-progress-bar");
          if (progressBar && typeof percentage === "number") {
            const clampedPercentage = Math.max(0, Math.min(100, percentage));
            progressBar.style.width = `${clampedPercentage}%`;
            progressBar.classList.remove("animating");
          }
        }
      };
    };
  
    const displaySelectedImage = (imageUrl) => {
      try {
        if (!imageUrl || !imageUrl.startsWith("https://")) return;
        const selectedOrientation = document.querySelector('input[name="availableProduct"]:checked').value;
        const existingIndex = generatedImages.findIndex(img => img.url === imageUrl);
        if (existingIndex !== -1) {
          if (selectedOrientation !== (generatedImages[existingIndex].orientation || "176578")) {
            const addToCartBtn = document.querySelector(".tee-btn--atc");
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
              addToCartBtn.style.opacity = "0.5";
            }
            return;
          }
        }
        if (existingIndex !== -1) {
          currentImageIndex = existingIndex;
          cleanCdnUrl = generatedImages[existingIndex].clean_cdn;
          sessionToken = generatedImages[existingIndex].session;
          previewUrl = generatedImages[existingIndex].url;
          isRegistered = generatedImages[existingIndex].registered || false;
          const thumbnailsContainer = document.querySelector(".disney-thumbnails");
          if (thumbnailsContainer) {
            thumbnailsContainer.querySelectorAll("div").forEach((div, index) => {
              div.style.border = index === existingIndex ? "2px solid #e6c992" : "none";
            });
          }
          addDisneyPropertiesToForm();
          if (!generatedImages[existingIndex].registered) {
            isFinalizationInProgress = false;
            isFinalized = false;
          }
          const addToCartBtn = document.querySelector(".tee-btn--atc");
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            addToCartBtn.style.opacity = "1";
          }
        }
        const verticalRadio = document.querySelector('.tee-radio input[value="176578"]');
        const isVertical = verticalRadio && verticalRadio.closest(".tee-radio").classList.contains("active");
        const galleryContent = document.querySelector(".tee-gallery-content");
        const activeSlide = document.querySelector(".tee-slide--active") || document.querySelector(".tee-slide.disney-generated");
        if (!galleryContent && !activeSlide) return;
        document.querySelectorAll(".disney-frame-display").forEach(el => el.remove());
        const frameDisplay = document.createElement("div");
        frameDisplay.className = "disney-frame-display";
        frameDisplay.style.cssText = `position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #f5f0e5; z-index: 100; display: flex; align-items: center; justify-content: center; padding: 40px; box-sizing: border-box;`;
        const frameImage = document.createElement("img");
        frameImage.className = "disney-frame-image";
        frameImage.alt = "Disney AI Generated";
        frameImage.src = imageUrl;
        frameImage.style.cssText = `max-width: ${isVertical ? "65%" : "85%"}; max-height: ${isVertical ? "85%" : "65%"}; object-fit: contain; box-shadow: 0 20px 30px rgba(0, 0, 0, 0.4), 0 6px 12px rgba(0, 0, 0, 0.3);`;
        frameDisplay.appendChild(frameImage);
        if (activeSlide) {
          activeSlide.appendChild(frameDisplay);
        } else {
          galleryContent.appendChild(frameDisplay);
        }
        frameDisplay.style.display = "flex";
        frameDisplay.style.opacity = "1";
        frameDisplay.style.visibility = "visible";
      } catch (error) {}
    };
  
    const hideOriginalImages = () => {
      try {
        document.querySelectorAll(".tee-slide:not(.disney-generated)").forEach(slide => {
          slide.querySelectorAll("img, svg").forEach(media => {
            media.style.opacity = "0";
            media.style.visibility = "hidden";
          });
          slide.classList.add("disney-hidden-original");
        });
        const thumbnailsTrack = document.querySelector(".tee-thumbnails__track");
        if (thumbnailsTrack) thumbnailsTrack.parentElement.style.display = "none";
        document.querySelectorAll(".tee-slider__button").forEach(button => {
          button.style.display = "none";
        });
        const sliderDots = document.querySelector(".tee-slider__dots");
        if (sliderDots) sliderDots.style.display = "none";
      } catch (error) {}
    };
  
    const addGeneratedImage = (imageUrl, setAsActive = true) => {
      if (!imageUrl || !imageUrl.startsWith("https://")) return;
      const validDomains = [
        "shopify-staged-uploads.storage.googleapis.com",
        "cdn.teeinblue.com", 
        "storage.googleapis.com"
      ];
      try {
        const urlObj = new URL(imageUrl);
        if (!validDomains.some(domain => urlObj.hostname.includes(domain))) return;
      } catch (error) {
        return;
      }
      if (!generatedImages.some(img => img.url === imageUrl)) {
        const orientation = document.querySelector('input[name="availableProduct"]:checked').value;
        generatedImages.push({
          url: imageUrl,
          clean_cdn: cleanCdnUrl,
          session: sessionToken,
          orientation: orientation,
          registered: false,
          productId: uniqueProductId
        });
        if (generatedImages.length > 3) generatedImages = generatedImages.slice(-3);
        localStorage.setItem("disney_generated_images", JSON.stringify(generatedImages));
      }
      previewUrl = imageUrl;
      if (document.querySelectorAll(".disney-hidden-original").length === 0) hideOriginalImages();
      if (setAsActive) currentImageIndex = generatedImages.findIndex(img => img.url === imageUrl);
      const sliderTrack = document.querySelector(".tee-slider__track");
      if (sliderTrack) {
        if (setAsActive) {
          document.querySelectorAll(".tee-slide--active").forEach(slide => {
            slide.classList.remove("tee-slide--active");
          });
        }
        const newSlide = document.querySelector(".tee-slide").cloneNode(true);
        newSlide.className = setAsActive ? "tee-slide tee-slide--active disney-generated" : "tee-slide disney-generated";
        const slideImage = newSlide.querySelector("img, svg");
        if (slideImage) slideImage.src = imageUrl;
        sliderTrack.appendChild(newSlide);
      }
      const thumbnailsTrack = document.querySelector(".tee-thumbnails__track");
      if (thumbnailsTrack) {
        if (setAsActive) {
          thumbnailsTrack.querySelectorAll(".tee-thumbnail--active").forEach(thumb => {
            thumb.classList.remove("tee-thumbnail--active");
          });
        }
        const newThumbnail = document.createElement("div");
        newThumbnail.className = setAsActive ? "tee-thumbnail tee-thumbnail-img--1-1 tee-thumbnail--active disney-generated-thumb" : "tee-thumbnail tee-thumbnail-img--1-1 disney-generated-thumb";
        newThumbnail.style.cssText = "width: 194.25px; height: 194.25px;";
        newThumbnail.innerHTML = `<img class="tee-mockup-thumbnail disney-generated-thumb" src="${imageUrl}" alt="Disney AI Generated" width="100" height="100" data-index="${generatedImages.findIndex(img => img.url === imageUrl)}">`;
        newThumbnail.addEventListener("click", function() {
          thumbnailsTrack.querySelectorAll(".tee-thumbnail").forEach(thumb => {
            thumb.classList.remove("tee-thumbnail--active");
          });
          this.classList.add("tee-thumbnail--active");
          const imageIndex = parseInt(this.querySelector("img").dataset.index);
          if (imageIndex >= 0 && imageIndex < generatedImages.length) {
            const selectedImage = generatedImages[imageIndex];
            displaySelectedImage(selectedImage.url);
          }
        });
        thumbnailsTrack.appendChild(newThumbnail);
      }
      const miniThumbnailsContainer = document.querySelector(".disney-thumbnails");
      if (miniThumbnailsContainer) {
        miniThumbnailsContainer.innerHTML = "";
        generatedImages.forEach((image, index) => {
          const miniThumb = document.createElement("div");
          miniThumb.style.cssText = "width: 80px; height: 80px; border-radius: 4px; overflow: hidden; cursor: pointer; transition: transform 0.2s;";
          miniThumb.innerHTML = `<img src="${image.url}" alt="Disney AI Generated" style="width: 100%; height: 100%; object-fit: cover;" data-index="${index}">`;
          miniThumb.addEventListener("mouseenter", () => {
            miniThumb.style.transform = "scale(1.05)";
          });
          miniThumb.addEventListener("mouseleave", () => {
            miniThumb.style.transform = "scale(1)";
          });
          miniThumb.addEventListener("click", function() {
            const imageIndex = parseInt(this.querySelector("img").dataset.index);
            if (imageIndex >= 0 && imageIndex < generatedImages.length) {
              const selectedImage = generatedImages[imageIndex];
              displaySelectedImage(selectedImage.url);
            }
          });
          miniThumbnailsContainer.appendChild(miniThumb);
          if (index === currentImageIndex) miniThumb.style.border = "2px solid #e6c992";
        });
      }
      if (setAsActive) displaySelectedImage(imageUrl);
      hasDisneyImage = true;
      addDisneyPropertiesToForm();
    };
  
    const resetDisneyGenerator = () => {
      clearDisneyDisplay();
      remainingTries = 3;
      localStorage.setItem("disney_remaining_tries", remainingTries.toString());
      sessionToken = null;
      localStorage.removeItem("disney_session");
      cleanCdnUrl = null;
      previewUrl = null;
      generatedImages = [];
      localStorage.setItem("disney_generated_images", JSON.stringify(generatedImages));
      currentImageIndex = -1;
      uniqueProductId = Date.now() + "-" + Math.floor(Math.random() * 1000);
      hasDisneyImage = false;
      isRegistered = false;
      isFinalized = false;
      isFinalizationInProgress = false;
      noteUpdateSuccess = false;
      noteUpdateAttempts = 0;
      if (retryTimeout) {
        clearTimeout(retryTimeout);
        retryTimeout = null;
      }
      retryCount = 0;
      const remainingCountEl = document.querySelector(".disney-remaining-count");
      if (remainingCountEl) remainingCountEl.textContent = remainingTries;
      const generateBtn = document.querySelector(".disney-generate-btn");
      if (generateBtn) {
        generateBtn.textContent = "Générer";
        generateBtn.disabled = false;
      }
      document.querySelectorAll(".disney-hidden-original").forEach(slide => {
        slide.classList.remove("disney-hidden-original");
        slide.querySelectorAll("img, svg").forEach(media => {
          media.style.opacity = "1";
          media.style.visibility = "visible";
        });
      });
      const thumbnailsTrack = document.querySelector(".tee-thumbnails__track");
      if (thumbnailsTrack && thumbnailsTrack.parentElement) {
        thumbnailsTrack.parentElement.style.display = "";
      }
      document.querySelectorAll(".tee-slider__button").forEach(button => {
        button.style.display = "";
      });
      const sliderDots = document.querySelector(".tee-slider__dots");
      if (sliderDots) sliderDots.style.display = "";
      const addToCartBtn = document.querySelector(".tee-btn--atc");
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "0.5";
      }
    };
  
    const clearDisneyDisplay = () => {
      try {
        document.querySelectorAll(".tee-slide.disney-generated").forEach(slide => {
          slide.remove();
        });
        document.querySelectorAll(".disney-generated-thumb").forEach(thumb => {
          const container = thumb.closest(".tee-thumbnail");
          if (container) {
            container.remove();
          } else {
            thumb.remove();
          }
        });
        const miniThumbnailsContainer = document.querySelector(".disney-thumbnails");
        if (miniThumbnailsContainer) miniThumbnailsContainer.innerHTML = "";
        const frameDisplay = document.querySelector(".disney-frame-display");
        if (frameDisplay) frameDisplay.remove();
        document.querySelectorAll(".disney-property-field").forEach(field => field.remove());
      } catch (error) {}
    };
  
    const checkGenerationStatus = async (sessionToken, loadingInterface, intervalId) => {
      try {
        const response = await fetch(`${API_BASE_URL}/checkGenerationStatus`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session: sessionToken })
        });
        if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
        const result = await response.json();
        if (result.success) {
          if (result.status === "completed") {
            clearInterval(intervalId);
            sessionToken = sessionToken;
            previewUrl = result.ai_url;
            if (result.clean_cdn) cleanCdnUrl = result.clean_cdn;
            isRegistered = false;
            isFinalized = false;
            isFinalizationInProgress = false;
            noteUpdateSuccess = false;
            const remainingCountEl = document.querySelector(".disney-remaining-count");
            if (remainingCountEl) remainingCountEl.textContent = result.remaining;
            addGeneratedImage(result.ai_url);
            addDisneyPropertiesToForm();
            if (!isFinalized && cleanCdnUrl) {
              try {
                await finalizeImage();
              } catch (err) {}
            }
            const addToCartBtn = document.querySelector(".tee-btn--atc");
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.style.opacity = "1";
              addToCartBtn.dataset.disneyReady = "true";
              if (!addToCartBtn.dataset.disneyHandled) {
                addToCartBtn.dataset.disneyHandled = "true";
                addToCartBtn.addEventListener("click", function() {
                  setTimeout(() => {
                    updateCartNote();
                    setTimeout(() => retryNoteUpdate(), 3000);
                  }, 1000);
                });
              }
            }
            remainingTries = result.remaining;
            localStorage.setItem("disney_remaining_tries", remainingTries.toString());
            const generateBtn = document.querySelector(".disney-generate-btn");
            if (generateBtn) {
              if (remainingTries > 0) {
                generateBtn.textContent = "Régénérer";
                generateBtn.disabled = false;
              } else if (generateBtn) {
                generateBtn.textContent = "Générer un autre tableau";
                generateBtn.disabled = false;
              } else {
                generateBtn.textContent = "Limite atteinte";
                generateBtn.disabled = true;
              }
            }
            if (loadingInterface) loadingInterface.complete(true);
            localStorage.removeItem("disney_generation_in_progress");
            localStorage.removeItem("disney_generation_data");
            isGenerating = false;
            hasDisneyImage = true;
            return true;
          }
          if (loadingInterface && typeof result.progress === "number") {
            loadingInterface.updateProgress(result.progress);
          }
          return false;
        }
        return false;
      } catch (error) {
        return false;
      }
    };
  
    const initializeDisneyGenerator = async () => {
      uniqueProductId = Date.now() + "-" + Math.floor(Math.random() * 1000);
      const isFirstLoad = !sessionStorage.getItem("disney_page_initialized");
      sessionStorage.setItem("disney_page_initialized", "true");
      if (isFirstLoad) {
        sessionStorage.removeItem("disney_selected_orientation");
        sessionStorage.removeItem("disney_selected_size");
      }
      try {
        const cartResponse = await fetch("/cart.js");
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          hasDisneyItemInCart = cart.items.some(item => 
            item.product_title?.toLowerCase().includes("disney") || 
            (item.properties && item.properties.DisneyPreviewURL)
          );
        }
      } catch (error) {}
      setupEventListeners();
      const formActions = document.querySelector("#teeFormActions");
      const formWrapper = document.querySelector(".tee-form-atc-wrapper");
      if (!formActions || !formWrapper) {
        setTimeout(initializeDisneyGenerator, 500);
        return;
      }
      if (document.querySelector(".disney-generator-internal")) return;
      const generatorContainer = document.createElement("div");
      generatorContainer.className = "disney-generator-internal";
      generatorContainer.dataset.backendUrl = API_BASE_URL;
      generatorContainer.style.cssText = "margin: 20px 0; padding: 15px; border: 1px solid #e8e8e8; border-radius: 8px; background-color: #f9f9f9; position: relative;";
      const loadingOverlay = document.createElement("div");
      loadingOverlay.className = "disney-loading-overlay";
      loadingOverlay.innerHTML = `<div class="disney-loading-container"><div class="disney-loading-text">Génération en cours<span class="disney-loading-dots">...</span></div><div class="disney-loading-progress-container"><div class="disney-loading-progress-bar">&nbsp;</div></div><div class="disney-loading-subtext">Veuillez patienter quelques instants pendant que nous créons votre portrait Disney</div></div>`;
      loadingOverlay.style.display = "none";
      document.body.appendChild(loadingOverlay);
      const styleSheet = document.createElement("style");
      styleSheet.textContent = `.disney-loading-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.7);display:flex;justify-content:center;align-items:center;z-index:10000}.disney-loading-container{background:white;border-radius:12px;padding:30px;text-align:center;max-width:80%;width:400px;box-shadow:0 5px 15px rgba(0,0,0,0.3)}.disney-loading-text{font-size:20px;font-weight:bold;margin-bottom:15px;color:#333}.disney-loading-dots{display:inline-block;width:24px;text-align:left;animation:disney-dots 1.5s infinite}.disney-loading-progress-container{width:100%;height:12px;background:#f3f3f3;border-radius:6px;margin-bottom:15px;overflow:hidden}.disney-loading-progress-bar{height:100%;width:0%;background:#e6c992;border-radius:6px}.disney-loading-progress-bar.animating{animation:disney-progress 60s linear forwards}.disney-loading-progress-bar.complete{animation:none;transition:width 0.5s ease;width:100%!important}.disney-loading-subtext{font-size:14px;color:#666;max-width:300px;margin:0 auto}@keyframes disney-dots{0%{content:'.'}25%{content:'..'}50%{content:'...'}75%{content:'..'}100%{content:'.'}}@keyframes disney-progress{0%{width:0%}100%{width:79%}}@media(max-width:767px){.disney-loading-container{padding:20px;width:90%}.disney-loading-text{font-size:16px}.disney-loading-progress-container{height:8px}.disney-loading-subtext{font-size:12px}}.disney-auth-overlay{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:1000;border-radius:8px}.disney-auth-message{color:white;font-size:18px;font-weight:bold;margin-bottom:20px;text-align:center;padding:0 20px}.disney-auth-buttons{display:flex;flex-direction:row;gap:15px}`;
      document.head.appendChild(styleSheet);
      const buttonText = remainingTries <= 0 && hasDisneyItemInCart ? "Générer un autre tableau" : remainingTries <= 0 ? "Limite atteinte" : "Générer";
      const isButtonDisabled = remainingTries <= 0 && !hasDisneyItemInCart;
      generatorContainer.innerHTML = `<button type="button" class="disney-generate-btn" style="width: 100%; padding: 10px; margin-bottom: 10px; background-color: #e6c992; color: #333; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;" ${isButtonDisabled ? "disabled" : ""}>${buttonText}</button><div style="text-align: center; font-size: 14px; margin-bottom: 15px; color: #666;"><span class="disney-remaining-count">${remainingTries}</span> générations restantes</div><div class="disney-thumbnails" style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 15px;"></div>`;
      formActions.insertBefore(generatorContainer, formWrapper);
      const checkUserAuthentication = () => {
        return window.meta && window.meta.page && window.meta.page.customerId;
      };
      const setupDisneyAuthOverlay = () => {
        const disneyGeneratorContainer = document.querySelector(".disney-generator-internal");
        if (!disneyGeneratorContainer) return false;
        if (!checkUserAuthentication()) {
          if (document.querySelector(".disney-auth-overlay")) return true;
          const overlay = document.createElement("div");
          overlay.className = "disney-auth-overlay";
          const message = document.createElement("div");
          message.className = "disney-auth-message";
          message.textContent = "Veuillez vous connecter pour accéder au générateur Disney";
          overlay.appendChild(message);
          const buttonContainer = document.createElement("div");
          buttonContainer.className = "disney-auth-buttons";
          const loginButton = document.createElement("a");
          loginButton.href = "/customer_authentication/login?return_to=/products/toile-disney";
          loginButton.className = "disney-login-btn";
          loginButton.textContent = "Se connecter";
          loginButton.style.cssText = `background-color: #e6c992; color: #333; padding: 10px 20px; border-radius: 4px; font-weight: bold; text-decoration: none; cursor: pointer; transition: background-color 0.3s;`;
          loginButton.addEventListener("mouseenter", () => {
            loginButton.style.backgroundColor = "#d9b775";
          });
          loginButton.addEventListener("mouseleave", () => {
            loginButton.style.backgroundColor = "#e6c992";
          });
          buttonContainer.appendChild(loginButton);
          const registerButton = document.createElement("a");
          registerButton.href = "/customer_authentication/login?return_to=/products/toile-disney";
          registerButton.className = "disney-register-btn";
          registerButton.textContent = "Créer un compte";
          registerButton.style.cssText = `background-color: white; color: #333; padding: 10px 20px; border-radius: 4px; font-weight: bold; text-decoration: none; cursor: pointer; transition: background-color 0.3s;`;
          registerButton.addEventListener("mouseenter", () => {
            registerButton.style.backgroundColor = "#f0f0f0";
          });
          registerButton.addEventListener("mouseleave", () => {
            registerButton.style.backgroundColor = "white";
          });
          buttonContainer.appendChild(registerButton);
          overlay.appendChild(buttonContainer);
          disneyGeneratorContainer.appendChild(overlay);
          return true;
        }
        return false;
      };
      setupDisneyAuthOverlay();
      const photoUploadField = document.querySelector(".tee-field--photo");
      if (photoUploadField && !checkUserAuthentication()) {
        photoUploadField.style.pointerEvents = "none";
      }
      setInterval(() => {
        if (checkUserAuthentication()) {
          const overlay = document.querySelector(".disney-auth-overlay");
          if (overlay) overlay.remove();
          const photoUploadField = document.querySelector(".tee-field--photo");
          if (photoUploadField) photoUploadField.style.pointerEvents = "auto";
          const generateBtn = document.querySelector(".disney-generate-btn");
          if (generateBtn && (remainingTries > 0 || hasDisneyItemInCart)) {
            generateBtn.disabled = false;
            generateBtn.style.opacity = "1";
          }
        } else {
          setupDisneyAuthOverlay();
          const photoUploadField = document.querySelector(".tee-field--photo");
          if (photoUploadField) photoUploadField.style.pointerEvents = "none";
        }
      }, 1000);
      const generateBtn = generatorContainer.querySelector(".disney-generate-btn");
      const remainingCountEl = generatorContainer.querySelector(".disney-remaining-count");
      const addToCartBtn = document.querySelector(".tee-btn--atc");
      const sliderTrack = document.querySelector(".tee-slider__track");
      const thumbnailsTrack = document.querySelector(".tee-thumbnails__track");
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "0.5";
      }
      const photoObserver = new MutationObserver(() => {
        if (document.querySelector(".tee-photo-image") && generateBtn.disabled && (remainingTries > 0 || hasDisneyItemInCart) && checkUserAuthentication()) {
          generateBtn.disabled = false;
          generateBtn.style.opacity = "1";
          photoObserver.disconnect();
        }
      });
      photoObserver.observe(document.body, { childList: true, subtree: true });
      if (document.querySelector(".tee-photo-image") && (remainingTries > 0 || hasDisneyItemInCart) && checkUserAuthentication()) {
        generateBtn.disabled = false;
        generateBtn.style.opacity = "1";
      }
      const generationInProgress = localStorage.getItem("disney_generation_in_progress") === "true";
      if (generationInProgress && sessionToken) {
        let generationData = {};
        try {
          generationData = JSON.parse(localStorage.getItem("disney_generation_data") || "{}");
        } catch (e) {
          generationData = {};
        }
        const maxAge = 10 * 60 * 1000;
        const isExpired = (Date.now() - (generationData.startTime || 0)) > maxAge;
        if (isExpired) {
          localStorage.removeItem("disney_generation_in_progress");
          localStorage.removeItem("disney_generation_data");
          generateBtn.textContent = "Générer";
          generateBtn.disabled = !checkUserAuthentication();
          isGenerating = false;
        } else {
          isGenerating = true;
          generateBtn.disabled = true;
          generateBtn.textContent = "Chargement...";
          const loadingInterface = createLoadingInterface();
          let dotsInterval = null;
          if (loadingInterface) dotsInterval = loadingInterface.start();
          const statusCheckInterval = setInterval(async () => {
            const completed = await checkGenerationStatus(sessionToken, loadingInterface, statusCheckInterval);
            if (completed && dotsInterval) clearInterval(dotsInterval);
          }, 3000);
        }
      }
      setTimeout(() => {
        if (generatedImages.length > 0) {
          clearDisneyDisplay();
          if (generatedImages.length > 3) {
            generatedImages = generatedImages.slice(-3);
            localStorage.setItem("disney_generated_images", JSON.stringify(generatedImages));
          }
          hideOriginalImages();
          const lastImage = generatedImages[generatedImages.length - 1];
          if (lastImage) {
            cleanCdnUrl = lastImage.clean_cdn;
            sessionToken = lastImage.session;
            previewUrl = lastImage.url;
            currentImageIndex = generatedImages.length - 1;
            hasDisneyImage = true;
            isRegistered = lastImage.registered || false;
          }
          setTimeout(() => {
            generatedImages.forEach((image, index) => {
              const isActive = index === generatedImages.length - 1;
              if (image.url) addGeneratedImage(image.url, isActive);
            });
            if (currentImageIndex >= 0 && currentImageIndex < generatedImages.length) {
              const selectedImage = generatedImages[currentImageIndex];
              displaySelectedImage(selectedImage.url);
            }
            setTimeout(() => {
              if (cleanCdnUrl && previewUrl && sessionToken) {
                addDisneyPropertiesToForm();
                const addToCartBtn = document.querySelector(".tee-btn--atc");
                if (addToCartBtn) {
                  addToCartBtn.disabled = !checkUserAuthentication();
                  addToCartBtn.style.opacity = checkUserAuthentication() ? "1" : "0.5";
                  addToCartBtn.style.backgroundColor = "#e6c992";
                  if (!addToCartBtn.dataset.disneyHandled) {
                    addToCartBtn.dataset.disneyHandled = "true";
                    addToCartBtn.addEventListener("click", function(event) {
                      if (!checkUserAuthentication()) {
                        event.preventDefault();
                        return;
                      }
                      if (!isFinalizationInProgress && cleanCdnUrl) finalizeImage();
                      setTimeout(() => {
                        updateCartNote();
                        setTimeout(() => retryNoteUpdate(), 3000);
                      }, 3000);
                    });
                  }
                }
              }
              if (cleanCdnUrl && !isFinalized && !isFinalizationInProgress && checkUserAuthentication()) {
                finalizeImage().then(() => {}).catch(err => {});
              }
            }, 1000);
          }, 500);
        }
      }, 1000);
      generateBtn.addEventListener("click", async () => {
        if (generateBtn.disabled || isGenerating || !checkUserAuthentication()) return;
        if (remainingTries <= 0 && hasDisneyItemInCart) {
          resetDisneyGenerator();
          return;
        }
        isGenerating = true;
        generateBtn.disabled = true;
        generateBtn.textContent = "Chargement...";
        const uploadedImageSrc = document.querySelector(".tee-photo-image")?.src || "";
        const orientation = document.querySelector('.tee-radio input[value="176578"]') && 
                           document.querySelector('.tee-radio input[value="176578"]').closest(".tee-radio").classList.contains("active") ? 
                           "verticale" : "horizontale";
        localStorage.setItem("disney_generation_in_progress", "true");
        localStorage.setItem("disney_generation_data", JSON.stringify({
          startTime: Date.now(),
          originalImage: uploadedImageSrc,
          orientation: orientation,
          productId: uniqueProductId
        }));
        const loadingInterface = createLoadingInterface();
        let dotsInterval = null;
        if (loadingInterface) dotsInterval = loadingInterface.start();
        try {
          const photoImage = document.querySelector(".tee-photo-image");
          if (!photoImage) throw new Error("Aucune image téléchargée trouvée");
          const orientationRadio = document.querySelector('.tee-radio input[value="176578"]');
          const selectedOrientation = orientationRadio && orientationRadio.closest(".tee-radio").classList.contains("active") ? "verticale" : "horizontale";
          const generateResponse = await fetch(`${API_BASE_URL}/generate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              original_cdn: photoImage.src,
              variant_orientation: selectedOrientation,
              session: sessionToken
            })
          });
          if (!generateResponse.ok) {
            if (generateResponse.status === 429) {
              const backoffDelay = Math.min(5000 * Math.pow(2, retryCount), 60000);
              retryCount++;
              const loadingTextEl = document.querySelector(".disney-loading-text");
              const loadingSubtextEl = document.querySelector(".disney-loading-subtext");
              if (loadingTextEl) loadingTextEl.textContent = "Serveur occupé";
              if (loadingSubtextEl) loadingSubtextEl.textContent = `Nouvelle tentative dans ${Math.ceil(backoffDelay / 1000)} secondes...`;
              generateBtn.textContent = `Serveur occupé, nouvelle tentative dans ${Math.ceil(backoffDelay / 1000)}s...`;
              retryTimeout = setTimeout(() => {
                generateBtn.textContent = "Générer";
                generateBtn.disabled = !checkUserAuthentication();
                isGenerating = false;
                if (loadingInterface) loadingInterface.complete(true);
                localStorage.removeItem("disney_generation_in_progress");
                localStorage.removeItem("disney_generation_data");
                if (checkUserAuthentication()) generateBtn.click();
              }, backoffDelay);
              return;
            }
            throw new Error(`Erreur API: ${generateResponse.status}`);
          }
          const generateResult = await generateResponse.json();
          sessionToken = generateResult.session;
          localStorage.setItem("disney_session", sessionToken);
          if (generateResult.status === "processing") {
            const statusCheckInterval = setInterval(async () => {
              const completed = await checkGenerationStatus(sessionToken, loadingInterface, statusCheckInterval);
              if (completed && dotsInterval) clearInterval(dotsInterval);
            }, 3000);
          }
        } catch (error) {
          generateBtn.textContent = "Erreur, réessayer";
          generateBtn.disabled = !checkUserAuthentication();
          if (loadingInterface) loadingInterface.complete(true);
          localStorage.removeItem("disney_generation_in_progress");
          localStorage.removeItem("disney_generation_data");
        } finally {}
      });
      const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (addToCartForm) {
        addToCartForm.addEventListener("submit", function(event) {
          if (!checkUserAuthentication()) {
            event.preventDefault();
            return;
          }
          if (hasDisneyImage && cleanCdnUrl) {
            if (!isFinalizationInProgress) finalizeImage();
            setTimeout(() => {
              updateCartNote();
              setTimeout(() => retryNoteUpdate(), 3000);
            }, 1000);
          }
        });
      }
      setTimeout(() => {
        const addToCartBtn = document.querySelector(".tee-btn--atc");
        if (addToCartBtn && hasDisneyImage && cleanCdnUrl && previewUrl && !addToCartBtn.dataset.disneyHandled) {
          addToCartBtn.dataset.disneyHandled = "true";
          addToCartBtn.addEventListener("click", function(event) {
            if (!checkUserAuthentication()) {
              event.preventDefault();
              return;
            }
            if (!isFinalizationInProgress) finalizeImage();
            setTimeout(() => {
              updateCartNote();
              setTimeout(() => retryNoteUpdate(), 3000);
            }, 3000);
          });
        }
      }, 2000);
      if (hasDisneyImage && cleanCdnUrl && !isFinalizationInProgress) {
        setTimeout(() => {
          if (checkUserAuthentication()) finalizeImage();
        }, 5000);
      }
    };
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeDisneyGenerator);
    } else {
      initializeDisneyGenerator();
    }
  
  })();